import React, { Component } from 'react';
import PropTypes from 'prop-types';

class ModalModifyUser extends Component {

    onClose() {
        window.location.reload();
    }


  render() {
    // Render nothing if the "show" prop is false
    if(!this.props.show) {
      return null;
    }

    // The gray background
    const backdropStyle = {
      position: 'fixed',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      backgroundColor: 'rgba(0,0,0,0.8)',
      padding: 50,
      zIndex: 99
    };

    // The modal "window"
    const modalStyle = {
      backgroundColor: '#fff',
      borderRadius: 5,
      maxWidth: 1200,
      minHeight: 800,
      margin: '0 auto',
      padding: 10,
    };

    // <button onClick={this.props.onClose}>
    return (
      <div className="backdrop-pdf" style={backdropStyle}>
        <div className="modal-pdf" style={modalStyle}>
        <button type="button" className="close" style={{marginBottom: 10}} onClick={this.onClose}>&times;</button>
        {this.props.children}
          <div className="footer">
            <button style={{marginTop: 20}}  onClick={this.onClose} className="btn btn-info">
              Close
            </button>
          </div>
        </div>
      </div>
    );
  }
}

ModalModifyUser.propTypes = {
  onClose: PropTypes.func.isRequired,
  show: PropTypes.bool,
  children: PropTypes.node
};

export default ModalModifyUser;
